var _rect, _path, _rect2, _rect3, _path2, _path3, _path4, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _path5, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 149,
    viewBox: "0 0 352 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 352,
    height: 149,
    fill: "#E5E5E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-3524 -807C-3524 -808.105 -3523.1 -809 -3522 -809H27515C27516.1 -809 27517 -808.105 27517 -807V4981C27517 4982.1 27516.1 4983 27515 4983H-3522C-3523.1 4983 -3524 4982.1 -3524 4981V-807Z",
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1149,
    transform: "translate(-543 -409)",
    fill: "#F4F5F5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -471,
    y: -235,
    width: 1296,
    height: 783,
    rx: 8,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.116 0.78125C345.251 0.78125 351.845 7.37572 351.845 15.5104C351.845 23.6451 345.251 30.2396 337.116 30.2396H252.949C261.084 30.2396 267.678 36.8341 267.678 44.9688C267.678 53.1034 261.084 59.6979 252.949 59.6979H299.241C307.376 59.6979 313.97 66.2924 313.97 74.4271C313.97 82.5618 307.376 89.1562 299.241 89.1562H277.833C267.576 89.1562 259.262 95.7507 259.262 103.885C259.262 109.309 263.47 114.218 271.887 118.615C280.021 118.615 286.616 125.209 286.616 133.344C286.616 141.478 280.021 148.073 271.887 148.073H97.2409C89.1062 148.073 82.5117 141.478 82.5117 133.344C82.5117 125.209 89.1062 118.615 97.2409 118.615H15.1784C7.04369 118.615 0.449219 112.02 0.449219 103.885C0.449219 95.7507 7.04369 89.1562 15.1784 89.1562H99.3451C107.48 89.1562 114.074 82.5618 114.074 74.4271C114.074 66.2924 107.48 59.6979 99.3451 59.6979H46.7409C38.6062 59.6979 32.0117 53.1034 32.0117 44.9688C32.0117 36.8341 38.6062 30.2396 46.7409 30.2396H130.908C122.773 30.2396 116.178 23.6451 116.178 15.5104C116.178 7.37572 122.773 0.78125 130.908 0.78125H337.116ZM337.116 59.6979C345.251 59.6979 351.845 66.2924 351.845 74.4271C351.845 82.5618 345.251 89.1562 337.116 89.1562C328.981 89.1562 322.387 82.5618 322.387 74.4271C322.387 66.2924 328.981 59.6979 337.116 59.6979Z",
    fill: "#F4F8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M207.08 100.905L207.077 100.914C205.532 105.891 203.318 109.957 200.459 113.152L200.453 113.159C197.627 116.365 194.261 118.741 190.345 120.299C186.407 121.866 182.045 122.658 177.245 122.658C173.386 122.658 169.804 122.166 166.493 121.19C163.196 120.175 160.225 118.657 157.571 116.637C154.964 114.575 152.703 112 150.79 108.898C148.887 105.809 147.41 102.143 146.377 97.8821C145.346 93.5865 144.824 88.704 144.824 83.2251V65.6287C144.824 58.7518 145.608 52.8651 147.148 47.9459C148.736 42.9674 150.973 38.8984 153.833 35.7016C156.706 32.4912 160.096 30.1132 164.014 28.5544C167.952 26.9877 172.313 26.1953 177.113 26.1953C180.971 26.1953 184.526 26.7095 187.789 27.7263L187.798 27.7292L187.807 27.7319C191.1 28.7029 194.068 30.2195 196.721 32.2826L196.72 32.2826L196.73 32.2902C199.374 34.3044 201.63 36.8508 203.496 39.9455L203.496 39.9456L203.502 39.9562C205.405 43.0431 206.882 46.7299 207.915 51.0362L207.916 51.039C208.946 55.2891 209.468 60.1488 209.468 65.6287V83.2251C209.468 90.0553 208.663 95.9413 207.08 100.905ZM165.369 52.8147L165.367 52.8245L165.366 52.8344C164.862 55.5788 164.617 58.9008 164.617 62.7841V85.9373C164.617 89.1066 164.773 91.8979 165.091 94.3038L165.093 94.317L165.095 94.3302C165.457 96.6833 165.96 98.735 166.617 100.47L166.624 100.489L166.632 100.508C167.335 102.197 168.2 103.63 169.244 104.773L169.253 104.784L169.263 104.794C170.313 105.893 171.53 106.709 172.908 107.22C174.253 107.717 175.703 107.959 177.245 107.959C179.141 107.959 180.885 107.569 182.449 106.761C184.057 105.931 185.382 104.606 186.446 102.867C187.567 101.062 188.357 98.7649 188.859 96.0274C189.408 93.2341 189.675 89.8651 189.675 85.9373V62.7841C189.675 59.6579 189.497 56.9054 189.133 54.5352C188.815 52.1798 188.311 50.1356 187.6 48.4252C186.942 46.736 186.097 45.3137 185.039 44.2025C183.999 43.0658 182.788 42.2254 181.411 41.7102C180.098 41.1593 178.659 40.8948 177.113 40.8948C175.169 40.8948 173.379 41.309 171.77 42.1621C170.164 42.9929 168.841 44.318 167.778 46.0574C166.705 47.813 165.916 50.0838 165.369 52.8147Z",
    fill: "white",
    stroke: "#ACB2DA",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130.901 87.5243V104.724L55.25 104.204L55.25 87.5243L92.4088 28.8477H116.546L106.987 44.4926L97.4283 60.1375L80.2394 86.232L130.901 87.5243ZM121.177 28.8477V121.069H98.8837L99.8287 28.8477H121.177Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 131.16,
    y1: 105.426,
    x2: 131.16,
    y2: 86.9258,
    stroke: "#ACB2DA",
    strokeWidth: 2.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 92.4703,
    y1: 28.0881,
    x2: 54.9859,
    y2: 88.0881,
    stroke: "#ACB2DA",
    strokeWidth: 2.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 99.9774,
    y1: 53.6055,
    x2: 79.4622,
    y2: 86.5882,
    stroke: "#ACB2DA",
    strokeWidth: 2.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 100.17,
    y1: 88.4258,
    x2: 100.17,
    y2: 52.9434,
    stroke: "#ACB2DA",
    strokeWidth: 2.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 100.172,
    y1: 121.426,
    x2: 100.172,
    y2: 103.922,
    stroke: "#ACB2DA",
    strokeWidth: 2.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 120.17,
    y1: 121.426,
    x2: 120.17,
    y2: 104.426,
    stroke: "#ACB2DA",
    strokeWidth: 2.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 91.4199,
    y1: 28.6797,
    x2: 120.42,
    y2: 28.6797,
    stroke: "#ACB2DA",
    strokeWidth: 2.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 99.4199,
    y1: 120.176,
    x2: 121.42,
    y2: 120.176,
    stroke: "#ACB2DA",
    strokeWidth: 2.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 78.3887,
    y1: 87.1758,
    x2: 101.42,
    y2: 87.1758,
    stroke: "#ACB2DA",
    strokeWidth: 2.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 118.918,
    y1: 105.176,
    x2: 132.41,
    y2: 105.176,
    stroke: "#ACB2DA",
    strokeWidth: 2.5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 118.922,
    y1: 88.1758,
    x2: 132.387,
    y2: 88.1758,
    stroke: "#ACB2DA",
    strokeWidth: 2.5
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 55.1699,
    y1: 106.426,
    x2: 55.1699,
    y2: 87.4258,
    stroke: "#ACB2DA",
    strokeWidth: 2.5
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 54.4199,
    y1: 105.176,
    x2: 99.4199,
    y2: 105.176,
    stroke: "#ACB2DA",
    strokeWidth: 2.5
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 120.17,
    y1: 87.4258,
    x2: 120.17,
    y2: 27.4258,
    stroke: "#ACB2DA",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M296.862 87.5243V104.724L221.211 104.204V87.5243L258.37 28.8477H282.507L272.948 44.4926L263.389 60.1375L246.2 86.232L296.862 87.5243ZM287.138 28.8477V121.069H264.845L265.79 28.8477H287.138Z",
    fill: "white"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 297.121,
    y1: 105.426,
    x2: 297.121,
    y2: 86.9258,
    stroke: "#ACB2DA",
    strokeWidth: 2.5
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 258.431,
    y1: 28.0881,
    x2: 220.947,
    y2: 88.0881,
    stroke: "#ACB2DA",
    strokeWidth: 2.5
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 265.938,
    y1: 53.6055,
    x2: 245.423,
    y2: 86.5882,
    stroke: "#ACB2DA",
    strokeWidth: 2.5
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 266.131,
    y1: 88.4258,
    x2: 266.131,
    y2: 52.9434,
    stroke: "#ACB2DA",
    strokeWidth: 2.5
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 266.133,
    y1: 121.426,
    x2: 266.133,
    y2: 103.922,
    stroke: "#ACB2DA",
    strokeWidth: 2.5
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 286.131,
    y1: 121.426,
    x2: 286.131,
    y2: 104.426,
    stroke: "#ACB2DA",
    strokeWidth: 2.5
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 257.381,
    y1: 28.6797,
    x2: 286.381,
    y2: 28.6797,
    stroke: "#ACB2DA",
    strokeWidth: 2.5
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 265.381,
    y1: 120.176,
    x2: 287.381,
    y2: 120.176,
    stroke: "#ACB2DA",
    strokeWidth: 2.5
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 244.35,
    y1: 87.1758,
    x2: 267.381,
    y2: 87.1758,
    stroke: "#ACB2DA",
    strokeWidth: 2.5
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 284.879,
    y1: 105.176,
    x2: 298.371,
    y2: 105.176,
    stroke: "#ACB2DA",
    strokeWidth: 2.5
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 284.883,
    y1: 88.1758,
    x2: 298.348,
    y2: 88.1758,
    stroke: "#ACB2DA",
    strokeWidth: 2.5
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 221.131,
    y1: 106.426,
    x2: 221.131,
    y2: 87.4258,
    stroke: "#ACB2DA",
    strokeWidth: 2.5
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 220.381,
    y1: 105.176,
    x2: 265.381,
    y2: 105.176,
    stroke: "#ACB2DA",
    strokeWidth: 2.5
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 286.131,
    y1: 87.4258,
    x2: 286.131,
    y2: 27.4258,
    stroke: "#ACB2DA",
    strokeWidth: 2.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M243.98 98.9297H228.595M255.499 98.9303L249.356 98.9297",
    stroke: "#C0D6FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2046 57.7868L69.3687 78.9844M87.4359 49.1478L85.7759 51.8891",
    stroke: "#C0D6FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-3522 -808H27515V-810H-3522V-808ZM27516 -807V4981H27518V-807H27516ZM27515 4982H-3522V4984H27515V4982ZM-3523 4981V-807H-3525V4981H-3523ZM-3522 4982C-3522.55 4982 -3523 4981.55 -3523 4981H-3525C-3525 4982.66 -3523.66 4984 -3522 4984V4982ZM27516 4981C27516 4981.55 27515.6 4982 27515 4982V4984C27516.7 4984 27518 4982.66 27518 4981H27516ZM27515 -808C27515.6 -808 27516 -807.552 27516 -807H27518C27518 -808.657 27516.7 -810 27515 -810V-808ZM-3522 -810C-3523.66 -810 -3525 -808.657 -3525 -807H-3523C-3523 -807.552 -3522.55 -808 -3522 -808V-810Z",
    fill: "black",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.44f8260753895cb034fd63352904aa27.svg";
export { ForwardRef as ReactComponent };